import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import NotFound from '../../../NotFound';
import InputFilter from '../../../Filters/InputFilter';
import SelectComponent from '../../../Selects/SelectFilter';
import {useContext} from 'react';
import {Context} from '../../../../Helpers/Auth';
import TablePagination from '../../../TablePagination';

function Stock({hideTable, setHideTable, onRowClick, Item, dadosItem, codigoItem, nomeItem, currentPage, totalProdutos, ITEMS_PER_PAGE, setCurrentPage}) {
    //const history = useHistory();
    const {t} = useTranslation();
    const [openTab, setOpenTab] = React.useState(1);
    const idiomaAtual = localStorage.getItem('i18nextLng');

    const {isCard, setIsCard, openCards, formatarNumero} = useContext(Context);
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {dadosItem?.stock?.map((elemento, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row">{elemento.estabelecimento.value + ' - ' + elemento.estabelecimento.label}</div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('stockDisponivel')}:</div> {elemento.qtdStock}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('encCliente')}: </div> {elemento.qtdEncCliente}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('encFornecedor')}: </div> {elemento.qtdEncFornecedor}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('emOrcamento')}: </div> {elemento.qtdOrcamento}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('stockPrevisto')}: </div> {elemento.qtdTotal}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('PV1')}: </div> {formatarNumero(elemento.precoMinimo)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('PVR')}: </div> {formatarNumero(elemento.precoRecomendado)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('precoCampanha')}: </div> {formatarNumero(elemento.precoCampanha)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('observacoes')} {t('preco')}: </div> {elemento.obsercacoesCampanha}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {dadosItem.stock?.length == 0 && <NotFound frase={t('semStock')} />}

                        {/* {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )} */}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(dadosItem.stock?.length / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{dadosItem.stock?.length}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={dadosItem.stock?.length} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                ) : (
                    <div className="relative min-h-[300px] overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-6 py-3 w-90">
                                        {t('estabelecimento')}
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('stockDisponivel')}
                                    </th>
                                    <th scope="col" className=" py-3 w-96">
                                        {t('encCliente')}
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('encFornecedor')}
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('emOrcamento')}
                                    </th>
                                    <th scope="col" className="px-6 py-3 ">
                                        {t('stockPrevisto')}
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('PV1')}
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('PVR')}
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('precoCampanha')}
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('observacoes')} {t('preco')}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {dadosItem?.stock?.map(elemento => (
                                    <tr
                                        // key={dados.id}
                                        className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                        <th scope="row" className="px-6 py-3 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {elemento.estabelecimento.value + ' - ' + elemento.estabelecimento.label}
                                        </th>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{elemento.qtdStock}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{elemento.qtdEncCliente}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{elemento.qtdEncFornecedor}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{elemento.qtdOrcamento}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{elemento.qtdTotal}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{formatarNumero(elemento.precoMinimo)}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{formatarNumero(elemento.precoRecomendado)}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{formatarNumero(elemento.precoCampanha)}</td>
                                        <td className="px-6 py-1  text-blue-600 dark:text-blue-500">{elemento.obsercacoesCampanha}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {dadosItem.stock?.length == 0 && <NotFound frase={t('semStock')} />}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(dadosItem.stock?.length / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{dadosItem.stock?.length}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={dadosItem.stock?.length} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                        {/* {semDados && <NotFound frase={t('semRegistos')} />} */}

                        {/* {totalRegistos === undefined && (
            <NotFound frase={t('naoExistemClientes')} />
        )} */}

                        {/* {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )} */}
                    </div>
                )}
            </div>
        </>
    );
}

export default Stock;
